import React, { useEffect, useState } from 'react'
import Grid from "@mui/material/Grid"
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import SearchIcon from '@mui/icons-material/Search'
import { useGetEmLogsQuery } from '../../store/services/reportsService'
import ElegantLoader from '../../Components/Loader'
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'

const EmergencyDataLogs = () => {
    const gpsDataColumns = [
        { field: 'timestamp', header: 'Timestamp' },
        { field: 'rawData', header: 'Raw Data' }
    ];

    const [inputValue, setInputValue] = useState("")
    const [searchQuery, setSearchQuery] = useState("")
    const { data: emLogs, isLoading: emLogsLoading, error } = useGetEmLogsQuery(searchQuery)
    
    console.log('EmergencyDataLogs - emLogs:', emLogs);
    console.log('EmergencyDataLogs - isLoading:', emLogsLoading);
    console.log('EmergencyDataLogs - error:', error);
    
    const parseGpsData = (data) => {
        try {
            console.log('parseGpsData - Raw data received:', data);

            if (!data) {
                console.log('parseGpsData - No data provided');
                return [];
            }

            // Check different possible data structures
            let dataToProcess = data;
            if (data.data) {
                dataToProcess = data.data;
            }

            console.log('parseGpsData - Data to process:', dataToProcess);

            // If it's a string, try to parse it
            if (typeof dataToProcess === 'string') {
                dataToProcess = JSON.parse(dataToProcess);
            }

            // If it's not an array, return empty
            if (!Array.isArray(dataToProcess)) {
                console.log('parseGpsData - Data is not an array:', typeof dataToProcess);
                return [];
            }

            console.log('parseGpsData - Processing array with length:', dataToProcess.length);

            const result = dataToProcess.map(item => ({
                id: item.pk || item.id || Math.random(),
                timestamp: item.fields?.timestamp || item.timestamp || 'N/A',
                rawData: item.fields?.raw_data || item.raw_data || item.rawData || 'N/A',
                gpsDataArray: (item.fields?.raw_data || item.raw_data || item.rawData || '').split(',')
            }));

            console.log('parseGpsData - Parsed result:', result);
            return result;
        } catch (error) {
            console.error('parseGpsData - Error parsing GPS data:', error);
            console.error('parseGpsData - data structure:', data);
            return [];
        }
    }

    const handleInputChange = (e) => {
        setInputValue(e.target.value)
    }

    const handleSearch = (e) => {
        e.preventDefault()
        setSearchQuery(inputValue)
        console.log('Searching for IMEI:', inputValue)
    }

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <form onSubmit={handleSearch}>
                    <Grid container spacing={1} alignItems="center">
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Search by IMEI"
                                value={inputValue}
                                onChange={handleInputChange}
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                        <Grid item>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                startIcon={<SearchIcon />}
                                size="small"
                            >
                                Search
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Grid>
            <Grid item xs={12}>
                {emLogsLoading ? (
                    <ElegantLoader variant="circular" text="Loading..." transparent/>
                ) : error ? (
                    <div>Error loading data: {error.message || 'Unknown error'}</div>
                ) : (
                    (() => {
                        const parsedRows = parseGpsData(emLogs);
                        console.log('Final rows for table:', parsedRows);
                        return (
                            <Box sx={{ mt: 1 }}>
                                <Typography variant="h5" sx={{ mb: 1, fontWeight: 600 }}>
                                    Emergency Data Logs
                                </Typography>
                                <Paper elevation={1} sx={{ overflow: 'hidden' }}>
                                    <TableContainer>
                                        <Table size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ 
                                                        width: '200px', 
                                                        fontWeight: 600, 
                                                        backgroundColor: '#f5f5f5',
                                                        padding: '12px 16px'
                                                    }}>
                                                        Timestamp
                                                    </TableCell>
                                                    <TableCell sx={{ 
                                                        fontWeight: 600, 
                                                        backgroundColor: '#f5f5f5',
                                                        padding: '12px 16px'
                                                    }}>
                                                        Raw Data
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {parsedRows.map((row, index) => (
                                                    <TableRow key={row.id || index} hover>
                                                        <TableCell sx={{ 
                                                            width: '200px', 
                                                            padding: '8px 16px',
                                                            borderRight: '1px solid #e0e0e0'
                                                        }}>
                                                            {row.timestamp}
                                                        </TableCell>
                                                        <TableCell sx={{ 
                                                            padding: '8px 16px',
                                                            wordBreak: 'break-all'
                                                        }}>
                                                            {row.rawData}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Paper>
                            </Box>
                        );
                    })()
                )}
            </Grid>
        </Grid>
    )
}

export default EmergencyDataLogs
